import axios from 'axios'
import md5 from 'md5'
import {
  SUCCESS,
  ERROR,
  COMPANY_NOT_EXIST_ERROR,
  ENV_TYPE_WXWORK,
  APP_FORM_FLOW_NOT_INIT_ERROR,
  ENCODE_TYPE_ZEUS,
  DECODE_ERROR,
  FLOW_FORM_NOT_EXIST, ENV_TYPE_SMALLPROGRAM, ENV_TYPE_LARK_MINI_PROGRAM, ENV_TYPE_WXWORK_ZJ, ENV_TYPE_DINGTALK_ZJ
} from './types'
import {appId} from "../../assets/js/base_config"
import {NOT_FEATURE, FEATURE_OVERCLOCKING, FORM_SUBMIT_ERROR} from "../RyForm/types";
import {base64Decode, decodeData, encodeData, isString} from "../../assets/js/Untis";
import store from './index'
import router from "../router"

import contextVue from "../../src/main";

axios.defaults.baseURL = '/apaas/miniapp/api/apaas'
axios.defaults.headers['x-apaas-authorization'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyTmFtZSI6Iua4hSIsImV4cCI6MTU5ODQzMjE1MiwidXNlcklkIjozMX0.F0ifTXwt1eiAEXGyQWT1K92H0S0eW6Q4tJ_pkyonMNk'
const appid = appId()

const post = (url, data,baseURL) => {
	if(baseURL){
		  axios.defaults.baseURL = baseURL;
	}else{
		  axios.defaults.baseURL = '/apaas/miniapp/api/apaas'
	}
	return axios.post(url, data,baseURL).then(res => {
	  const token = res.headers['x-apaas-authorization']
	  if (token) {
	    axios.defaults.headers['x-apaas-authorization'] = token
	  }
if(res.data.status === 50010022){
      router.push('/account/disable')
    return
  }
	  
	  return res.data
	}).then(({resultObject, status, info}) => {
	
	  if (status === SUCCESS && isString(resultObject)) {
	    const result = resultObject.split(",")
	    const types = [ENCODE_TYPE_ZEUS]
	    if (result.length && result.length === 3 && types.includes(result[1])) {
	      const resultData = decodeData(resultObject)
	      return {
	        resultObject: resultData,
	        status: resultData ? SUCCESS : DECODE_ERROR,
	        info: resultData ? '' : '数据解析失败，请联系客服人员'
	      }
	    } else {
	      return {resultObject, status, info}
	    }
	  } else {
	    return {resultObject, status, info}
	  }
	}).then(({resultObject, status, info}) => {
	  if (status === NOT_FEATURE || status === FEATURE_OVERCLOCKING) {
	    store.dispatch("handelFeatureErrorCode", {
	      code: status,
	      info: info
	    })
	  } else {
	    return {resultObject, status, info}
	  }
	
	})
}

export function handelFeatureErrorCode(store, {code, info}) {
  try {
    switch (code) {
      case NOT_FEATURE:
      case FEATURE_OVERCLOCKING:
        let infoObj = {}
        if (!info && !info.length) {
          infoObj = {alert: '权益不足', redirectUrl: ''}
        } else {
          infoObj = JSON.parse(base64Decode(info))
          if (!infoObj) {
            infoObj = {alert: '权益不足', redirectUrl: ''}
          } else if (!infoObj.alert) {
            infoObj.alert = '权益不足'
          }
        }
        console.log(infoObj)
        this._vm.$toast.fail(infoObj.alert)
        break
      default:
        break
    }
  } catch (e) {
    console.log(e)
  }
}

// const post = (url, data, headers) => {
//   const head = {
//     'x-apaas-authorization': headers['x-apaas-authorization'] || '',
//     'user-agent': headers['user-agent'] || '',
//     'referer': headers['referer'] || '',
//     'x-forwarded-for': headers['x-forwarded-for'] || '',
//     'x-real-ip': headers['x-real-ip'] || '',
//     'x-apaas-real-ip': headers['x-apaas-real-ip'] || ''
//   }
//   return axios.post(url, data,{headers: head}).then(res => res.data)
// }
export function actionSetToken(store) {
  if (store.state.token) {
    axios.defaults.headers['x-apaas-authorization'] = store.state.token
  }
}

export function setPageTitle(store, title) {
  console.log('setPageTitle', title, this._vm.$dd)
  if (this._vm.$dd) {
      this._vm.$dd.ready(() => {
        this._vm.$dd.biz.navigation.setTitle({
          title
        })
      });
  }
}

// 获取微信小程序存储的数据
export function actionWechatNodeGet(store, key) {
  return axios.get(`/wechat/node/get?nodeKey=${key}`)
    .then(res => res.data)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        if (resultObject.appId) store.commit('UPDATE__APP_ID', resultObject.appId)
        if (resultObject.formId) store.commit('UPDATE__FORM_ID', resultObject.formId)
        if (resultObject.companyId) store.commit('UPDATE__COMPANY_ID', resultObject.companyId)
        if (resultObject.userId) store.commit('UPDATE__USER_ID', resultObject.userId)
        store.commit('UPDATE_CAN_NAV_BACK', resultObject.canNavBack)
        if (resultObject.adminInfo) store.commit('UPDATE_ADMIN', resultObject.adminInfo)
        if (resultObject.env) store.commit('UPDATE_ENV', resultObject.env)
        if (resultObject.token) {
          store.commit('UPDATE__TOKEN', resultObject.token)
          axios.defaults.headers['x-apaas-authorization'] = resultObject.token
        }
        if (resultObject.ip) axios.defaults.headers['x-real-ip'] = resultObject.ip
        if (resultObject.ip) axios.defaults.headers['x-apaas-real-ip'] = resultObject.ip
        if (resultObject.hasOwnProperty('showBack')) store.state.showBack = resultObject.showBack
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取注册存储的数据
export function actionWechatLoginNodeGet(store, key) {
  return axios.get(`/wechat/node/get?nodeKey=${key}`)
    .then(res => res.data)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        store.commit('UPDATE_CAN_NAV_BACK', resultObject.canNavBack)
        if (resultObject.adminInfo) store.commit('UPDATE_ADMIN', resultObject.adminInfo)
        if (resultObject.env) store.commit('UPDATE_ENV', resultObject.env)
        if (resultObject.token) {
          store.commit('UPDATE__TOKEN', resultObject.token)
          axios.defaults.headers['x-apaas-authorization'] = resultObject.token
        }
        if (resultObject.ip) axios.defaults.headers['x-real-ip'] = resultObject.ip
        if (resultObject.ip) axios.defaults.headers['x-apaas-real-ip'] = resultObject.ip
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 请求系统配置
export function getSystemConfig(store) {
  return post(`/ruyiflow/server/system/config/get`, {})
    .then(({status, resultObject, info}) => {
      if (status === 0) {
        store.commit('SET_SYSTEM_CONFIG', resultObject)
        console.log('systemConfig:', resultObject)
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 上传文件获取token
export function actionGetFileToken({state}, {files, companyId}) {

  let env = 'H5'
  if (store.getters.env === ENV_TYPE_SMALLPROGRAM) {
    env = 'MINIAPP'
  } else {
    if (window.isWxWork) {
      env = 'CPWECHAT'
    } else if (window.isWexin) {
      env = 'WECHAT'
    } else if (window.isLark) {
      env = 'LARK'
    }
  }

  return post('/fs/file/upload', {
    userId: state.userId,
    companyId: store.getters.currentCompanyId,
    appId: state.appId,
    formId: state.formId,
    uploadAgent: env, //新增字段 上传环境
    files
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status === FEATURE_OVERCLOCKING || status === NOT_FEATURE) {
      this._vm.$toast.fail('权益不足，无法上传图片')
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`/file/upload ${status}: ${info}`)
    }
  })
}

// 获取登录mqtt账户密码
export function actionGetAccount({state}) {
  return post(`/ruyiflow/app/form/mqtt/get`, {
    userId: state.userId,
    companyId: state.companyId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 表单提交的value详情
export function actionFetchFormApplyDetail(store, {formId, stepId = null, instanceId}) {
  const param = {
    userId: store.state.userId,
    companyId: store.state.companyId,
    formId: formId || store.state.formId,
    instanceId,
    stepId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/apply/ct/detail/v2', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_MAP', resultObject.memberDetailMap)
      store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalDetailMap)
      return {status, resultObject, info}
    } else {
      this._vm.$toast.fail(`${status} ${info}`)
      throw new Error(`${status} ${info}`)
    }
  })
}

// 表单提交临时提交 获取公式数据
export function actionFormDefaultSubmitData(store, {appId, formId, data}) {
  return post(`/ruyiflow/app/form/tmp/default/submit`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    data
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单按钮字段发起表单获取默认值填入表单 ， buttonId是button的dataId
export function actionFormButtonApplyData(store, {appId, formId, data, buttonId}) {
  return post(`/ruyiflow/app/form/button/get/data`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    data,
    buttonId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
export function actionFormRelateApplyData(store, {appId, formId, data, relateAppId, relateFormId, createMap, tableHandleList}) {
  return post(`/ruyiflow/app/form/relate/get/data`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    data,
    relateAppId,
    relateFormId,
    createMap,
    tableHandleList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function actionFormTableApplyData(store, {appId, formId, data, tableId}) {
  return post(`/ruyiflow/app/form/apply/table/start/data`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    data,
    tableId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取暂存数据
export function actionFetchTempData(store, {appId, formId}) {
  return post(`/ruyiflow/workspace/tmp/own/list`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取暂存数据
export function actionDeleteTempData(store, {recordId}) {
  return post(`/ruyiflow/workspace/tmp/own/delete`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    recordId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 更新表单数据
export function actionSaveFormData({state}, {appId, formId, instanceId, viewId, data, viewGroupId, operateId, refreshType, changeList, relateHandleMap, showFieldIdList}) {
  return post("/ruyiflow/app/form/apply/update", {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId,
    viewId,
    instanceId,
    data,
    viewGroupId,
    operateId,
    refreshType,
    changeList,
    relateHandleMap,
    showFieldIdList
  })
}

// 执行按钮操作前更新表单数据
export function actionExecuteSaveFormData({state}, {appId, formId, instanceId, viewId, data, viewGroupId, operateId, refreshType, changeList, relateHandleMap,showFieldIdList}) {
  return post("/ruyiflow/app/form/apply/execute/update", {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId,
    viewId,
    instanceId,
    data,
    viewGroupId,
    operateId,
    refreshType,
    changeList,
    relateHandleMap,
    showFieldIdList
  })
}


// 流程详情
export function actionFlowDetail(store, {userId, companyId, appId, formId, formType}) {

  const param = {
    userId,
    companyId,
    appId,
    formId,
    formType
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/encrypt/flow/detail/v2", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        if (resultObject.flowDetail) {
          resultObject.flowDetail.forEach(item => {
            store.commit('UPDATE_USER_MAP', item.memberDetailMap)
            store.commit('UPDATE_EXTERNAL_MAP', item.externalDetailMap)
          })
        }
        return resultObject
      } else if (status === APP_FORM_FLOW_NOT_INIT_ERROR) {
        this._vm.$toast.fail('表单流程尚未初始化')
        throw new Error(`${status} ${info}`)
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        this._vm.$toast.fail(info)
        throw new Error(`${status} ${info}`)
      }
    })
}

// viewType 0 工作台/外链/发起表单 1 视图  2 仪表盘 3 表单数据
export function actionMergeStructure(store, {appId, formId, stepId, formType, viewType, viewId, dashboardId, chartId, instanceId, permissionFlag}) {

  const param = {
    userId: store.state.userId,
    companyId: store.state.companyId,
    appId: appId ? appId : store.state.appId,
    formId: formId ? formId : store.state.formId,
    stepId,
    formType,
    viewType,
    viewId,
    dashboardId,
    chartId,
    instanceId,
    permissionFlag
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/encrypt/type/merge/structure/v2', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS || status === FLOW_FORM_NOT_EXIST) {
        store.commit('UPDATE_USER_MAP', resultObject.memberDetailMap)
        store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalDetailMap)
        return {status, resultObject, info}
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        if (status === 50030030) {
          console.log(this)
          this._vm.$dialog.alert({
            title: '您的团队已被暂停使用',
            message: '因为您的团队成员违反了平台使用协议，现将您的团队暂做封禁处理，如果您有任何疑问请联系在线客服。',
            theme: 'round-button'
          }).then(() => {
          })
        }
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 轻量级的表单struct接口
export function actionLiteMergeStructure(store, {appId, formId}) {

  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId ? appId : store.getters.currentAppId,
    formId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/encrypt/type/merge/structure/simple", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 表单申请详情-概述
export function actionFetchFormApplyOverview({state}, {companyId, appId, formId, stepId, instanceId}) {

  const param = {
    userId: state.userId,
    companyId,
    appId,
    formId,
    stepId,
    instanceId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/encrypt/apply/overview", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        // return {status, resultObject, info}
        return resultObject
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

export function actionFetchFormApplyLinkOverview({state}, {companyId, appId, formId, instanceId, stepId}) {

  const param = {
    userId: state.userId,
    companyId,
    appId,
    formId,
    stepId,
    instanceId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/out/encrypt/apply/overview", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        // return {status, resultObject, info}
        return resultObject
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

// 数据详情 单个卡片
export function actionFetchFormViewDataDetail(store, {appId, formId, instanceId, accessType, viewId, stepId}) {
  return post('/ruyiflow/app/form/apply/instance/detail/v2', {
    userId: store.state.userId,
    companyId: store.state.companyId,
    appId: appId || store.state.appId,
    formId: formId || store.state.formId,
    instanceId,
    accessType,
    viewId,
    stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      if (resultObject.data) {
        store.commit('UPDATE_USER_MAP', resultObject.data.memberDetailMap)
        store.commit('UPDATE_EXTERNAL_MAP', resultObject.data.externalDetailMap)
      }
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 按钮操作-数据视图详情点击按钮。确认调用接口
export function actionFetchButtonConfirm({state}, {formId, viewId, buttonId, instanceId}) {
  return post("/ruyiflow/app/form/view/button/execute", {
    userId: state.userId,
    companyId: state.companyId,
    appId: state.appId,
    formId,
    viewId,
    buttonId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取mqtt连接地址
export function mqttGet() {
  return axios.get('/ruyiflow/app/user/mqtt/get')
    .then(res => res.data)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject['mqttUrl']
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 表单提交获取临时topic
export function actionTopicGet({state}, opt) {
  const {companyId, appId, formId} = opt ? opt : {}
  return post(`/ruyiflow/app/form/topic/get`, {
    userId: state.userId,
    companyId: companyId || state.companyId,
    appId: appId || state.appId,
    formId: formId || state.formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取表单实例的buttonList
export function actionApplyButtonList({state}, {appId, formId, instanceId, stepId = null, enterFlag}) {
  return post('/ruyiflow/app/form/apply/button/list', {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId: formId || state.formId,
    instanceId,
    stepId,
    enterFlag
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单提交临时提交 获取公式数据-mqtt下发数据
export function actionTmpSubmit({state}, {companyId, appId, formId, rowIdx, instanceId, fieldId, data, tmpTopic, version}) {
  return post(`/ruyiflow/app/form/tmp/submit`, {
    userId: state.userId,
    companyId: companyId || state.companyId,
    appId: appId || state.appId,
    formId: formId || state.formId,
    rowIdx,
    instanceId,
    fieldId,
    data,
    tmpTopic,
    version
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 提交表单申请数据
export function formApply({state}, {appId, formId, openId, data, changeList, extField = null, relateHandleMap, showFieldIdList}) {
  return post('/ruyiflow/app/form/apply', {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId: formId || state.formId,
    openId,
    extField,
    changeList,
    data,
    relateHandleMap,
    showFieldIdList
  }).then(({status, resultObject, info}) => {
    return {status, resultObject, info}

  })
}

// 提交表单申请数据
export function formApplyWithParam({state}, {companyId, appId, formId, data, extField = null, relateHandleMap, showFieldIdList}) {
  return post('/ruyiflow/app/form/apply', {
    userId: state.userId,
    companyId,
    appId,
    formId,
    extField,
    data,
    isOutInput: 1,
    relateHandleMap,
    showFieldIdList
  })
}

// 表单申请处理
export function actionFormApplyHandle({state}, {
  appId, formId, instanceId, stepId, handleAction, data, changeList,
  comment, forwardTo, approveInfo, relateHandleMap, enterFlag, showFieldIdList
}) {
  return post('/ruyiflow/app/form/apply/handle', {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId: formId || state.formId,
    instanceId,
    stepId,
    handleAction,
    data,
    changeList,
    comment,
    forwardTo,
    approveInfo,
    relateHandleMap,
    enterFlag,
    showFieldIdList
  })
}

// 获取一个流程节点详细信息
export function actionFormFlowDetail(store, {companyId, formId, appId, stepId}) {
  return post("/ruyiflow/app/form/flow/one", {
    userId: store.getters.userId,
    companyId,
    formId,
    appId,
    stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单转交人可选范围获取
export function actionFetchFormForwardChooseList(store, {companyId, appId, formId, instanceId, stepId}) {
  return post("/ruyiflow/app/form/apply/forward/choose", {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    instanceId,
    stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 数据来源控件数据获取
export function actionExternalData({state}, {appId, formId, companyId, fieldId, data, rowIdx, queryStr, currentPage, pageSize}) {
  return post('/ruyiflow/app/form/apply/external/data', {
    userId: state.userId,
    companyId: companyId ? companyId : state.companyId,
    appId: appId ? appId : state.appId,
    formId: formId ? formId : state.formId,
    fieldId,
    data,
    rowIdx,
    queryStr,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalInfoMap)
      store.commit('UPDATE_USER_MAP', resultObject.memberMap)
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 用户信息校验
export function actionCheckUserExist(store, {countryCode, telephone}) {
  return post('/ruyiflow/app/user/exist/check', {
    countryCode,
    telephone
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 注册用户
export function userRegister(store, {countryCode, telephone, code, password, openId, userName, email, inviteCode, headImg}) {
  password = md5(password)
  return post('/ruyiflow/app/user/register', {
    countryCode,
    telephone,
    code,
    password,
    openId,
    userName,
    email,
    inviteCode,
    headImg
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(info)
    } else if (status === SUCCESS) {
      store.commit('UPDATE__TOKEN', axios.defaults.headers['x-apaas-authorization'])
      return {status, resultObject, info}
    } else {
      return {status, info}
    }
  })
}

// 获取手机验证码临时key
export function userCodeKeyGet(store) {
  return axios.get('/ruyiflow/app/user/tmp/key/get')
    .then(res => res.data)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取手机验证码
export function userCodeGet(store, {countryCode, telephone, type = 0, companyId = ''}) {
  return store.dispatch('userCodeKeyGet')
    .then(res => {
      const param = {
        countryCode,
        telephone,
        companyId,
        tmpKey: res.tmpKey
      }
      const encodeParam = {
        requestParam: encodeData({
          type: ENCODE_TYPE_ZEUS,
          data: param
        })
      }
      return post("/ruyiflow/app/form/encrypt/code/get", encodeParam)

    }).then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        this._vm.$toast.success(resultObject)
        return {status, info}
      } else {
        this._vm.$toast.fail(info)
        throw new Error(info)
      }
    })
  // return post('/ruyiflow/app/user/code/get', {
  //   countryCode,
  //   telephone,
  //   type
  // })
  //   .then(({status, resultObject, info}) => {
  //     if (status === ERROR) {
  //       this._vm.$toast.fail(info)
  //       throw new Error(info)
  //     } else {
  //       this._vm.$toast.success('resultObject')
  //       return {status, info}
  //     }
  //   })
}

// 邀请码兑换邀请信息
export function actionFetchCompanyInviteInfo(store, inviteCode) {
  return post('/ruyiflow/company/invite/detail', {
    inviteCode
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 判断用户是否是公司成员已经外部联系人
export function actionCompanyMemberCheck(store, {userId, companyId}) {
  return post('/ruyiflow/company/member/check', {
    userId,
    companyId,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 申请加入公司
export function actionCompanyApplyJoin(store, {userId, inviteCode, companyId}) {
  return post('/ruyiflow/company/apply/join', {
    userId,
    companyId,
    inviteCode
  })
}

// 申请加入团队外部联系人
export function actionExternalApply(store, {userId, inviteUserId, companyId}) {
  return post('/ruyiflow/external/apply', {
    userId,
    companyId,
    inviteUserId
  })
}

// 手机控件获取验证码
export function actionPhoneFieldGetCode({state}, phone) {
  return post('/ruyiflow/app/form/apply/send/code', {
    formId: state.formId,
    companyId: state.companyId,
    phone
  })
}

// 手机控件验证验证码
export function actionPhoneFieldCheckCode(store, {code, phone}) {
  return post('/ruyiflow/app/form/apply/check/code', {
    phone,
    code
  })
}

// 微信获取签名
export function actionWechatTicket(store, url) {
  if (window.isWxWork) {
    return post(`/sso/wx/oauth/create`, {
      requestUrl: url,
      companyId: store.getters.currentCompanyId,
      zjConfig: store.getters.env === ENV_TYPE_WXWORK_ZJ ? 'YES' : 'NO'
    }).then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
  } else {
    return post(`/wechat/ticket/${appid}/create`, {
      requestUrl: url
    }).then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
  }
}

// 飞书小程序获取签名
export function actionLarkTicket(store, url) {
  return post(`/ruyiflow/lark/sdk/create`, {
    requestUrl: url,
    companyId: store.getters.currentCompanyId || '200545767356628992'
    // companyId: '200545767356628992'
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 客户门户获取微信签名
export function actionSpaceWechatTicket(store, {url, companyId}) {
  if (window.isWxWork) {
    return post(`/sso/wx/oauth/create`, {
      requestUrl: url,
      companyId: companyId || store.getters.currentCompanyId,
      zjConfig: store.getters.env === ENV_TYPE_WXWORK_ZJ ? 'YES' : 'NO'
    })
  } else {
    return post(`/ruyiflow/api/sdk/create`, {
      requestUrl: url,
      companyId: companyId || store.getters.currentCompanyId
    })
  }
}

// 钉钉获取签名
export function actionDingtalkTicket(store, url) {
  return post(`/ruyiflow/dingtalk/sdk/create`, {
    requestUrl: url,
    companyId: store.getters.currentCompanyId,
    zjConfig:  store.getters.env.startsWith('dingtalk_custom') ? 'YES' : 'NO'
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 通过组件的Id list获取多个组件详情 --（服务器处理过子表单内部字段名。。加过点）
export function actionChooseFieldDetail({state}, {formId, userId, formType, sectionIdList, fieldIdList}) {
  return post('/ruyiflow/app/form/field/choose/detail', {
    companyId: state.companyId,
    formId,
    userId: state.userId,
    formType,
    sectionIdList,
    fieldIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取用户列表
export function getUserList(store, {userId, companyId}) {
  return post('/ruyiflow/company/member/list', {
    userId,
    companyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 数据汇总控件获取结果
export function actionFetchDataSummary({state}, {instanceIdList, fieldId, tmpTopic, filter}) {
  return post('/ruyiflow/app/form/summary/tmp/submit', {
    userId: state.userId,
    companyId: state.companyId,
    appId: state.appId,
    formId: state.formId,
    instanceIdList,
    fieldId,
    tmpTopic,
    version: Date.now(),
    filter
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 公司组织架构信息
export function companyDepInfo(store, companyId) {
  return post('/ruyiflow/company/dep/info', {
    companyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_ORGANIZATION', resultObject)
      return {status, resultObject, info}
    } else if (status === COMPANY_NOT_EXIST_ERROR) {
      this._vm.$toast.fail(`${status}: ${info}`)
      return {status, resultObject, info}
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 公司组织架构信息
export function fetchRoleList(store, {userId, companyId}) {
  return post('/ruyiflow/role/list', {
    userId: userId || store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_ROLE_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function organizationSearch(store, {userId, companyId, queryType, queryStr}) {
  return post('/ruyiflow/company/member/search', {
    userId,
    companyId,
    queryType, // member人员搜索，dep部门搜索，role角色搜索
    queryStr
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 地址信息兑换
export function actionMiniAppAddressGet(store, {latitude, longitude}) {
  return post('/wechat/miniapp/address/get', {
    latitude, longitude
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取用户视图list
export function actionFetchFormViewList(store, {userId, companyId, appId, formId}) {
  return post("/ruyiflow/app/form/view/get", {
    userId,
    companyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据的筛选获取表头
export function actionApplyHeader({state}, {formId, appId}) {

  const param = {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/encrypt/apply/header', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 数据视图表格header   /ruyiflow/app/form/view/header
export function actionFormDataViewHeader({state}, {appId, formId, viewId}) {

  const param = {
    userId: state.userId,
    companyId: state.companyId,
    appId: appId || state.appId,
    formId,
    viewId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/encrypt/view/header", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 表单数据的筛选
export function actionApplyList(store, {appId, formId, sort, filter, pageSize, currentPage, allPreData}) {
  const param = {
    userId: store.state.userId,
    companyId: store.state.companyId,
    appId: appId || store.state.appId,
    formId,
    currentPage,
    pageSize: pageSize,
    sort,
    filter,
    allPreData
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/apply/ct/list/v2', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      resultObject.dataList.forEach(item => {
        store.commit('UPDATE_USER_MAP', item.memberDetailMap)
        store.commit('UPDATE_EXTERNAL_MAP', item.externalDetailMap)
      })
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 获取关联表单数据
export function actionFetchRelateFormData(store, {appId, formId, instanceId, data, currentPage, pageSize, sort, filterInfo}) {
  return post("/ruyiflow/app/form/apply/relate/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    instanceId,
    data,
    currentPage,
    pageSize,
    sort,
    filterInfo
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据的筛选
export function actionApplyBatch(store, {appId, formId, instanceIdList}) {
  return post('/ruyiflow/app/form/apply/batch/get', {
    userId: store.getters.userId || '',
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    currentPage: 1,
    pageSize: 100000,
    instanceIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 数据视图数据
export function actionFormDataViewData(store, {appId, formId, viewId, data, instanceId, sortList, filter, currentPage, pageSize, allPreData}) {
  return post("/ruyiflow/app/form/view/data/v2", {
    userId: store.state.userId,
    companyId: store.state.companyId,
    appId: appId || store.state.appId,
    formId,
    viewId,
    data,
    instanceId,
    sortList,
    filter,
    currentPage,
    pageSize,
    allPreData
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      resultObject.dataList.forEach(item => {
        store.commit('UPDATE_USER_MAP', item.memberDetailMap)
        store.commit('UPDATE_EXTERNAL_MAP', item.externalDetailMap)
      })
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 相册视图获取数据
export function actionFormViewPhotoData(store, {companyId, appId, formId, viewId, filterInfo, requestToken, dataMaxIndex, slotDataMaxIndex, maxSlotId, pageSize}) {
  return post(`/ruyiflow/app/form/view/gallery/data`, {
    userId: store.getters.userId,
    companyId: companyId ? companyId : store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId,
    filterInfo,
    requestToken,
    dataMaxIndex,
    slotDataMaxIndex,
    maxSlotId,
    pageSize,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 设置子表单宽度
export function actionSettingTableWidth({state}, {appId, companyId, formId, fieldId, fieldWidth}) {
  return post('/ruyiflow/app/form/table/width/set', {
    userId: store.userId,
    appId,
    companyId,
    formId,
    fieldId,
    fieldWidth
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取子表单宽度
export function actionFetchTableWidth({state}, formId) {
  return post('/ruyiflow/app/form/table/width/get', {
    userId: state.userId,
    companyId: state.companyId,
    appId: state.appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取视图详情
export function actionFetchFormViewDetail(store, {companyId, formId, viewId}) {
  return post("/ruyiflow/app/form/view/detail/v2", {
    userId: store.state.userId,
    companyId: companyId || store.state.companyId,
    appId: store.state.appId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_MAP', resultObject.memberDetailMap)
      store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalDetailMap)
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}
// 表单数据是否能打印
export function actionViewDataPrintPermission(store, {companyId, appId, formId, viewId}) {
  return post(`/ruyiflow/app/form/view/print/permission`, {
    userId: store.getters.userId,
    companyId: companyId || store.state.companyId,
    appId: store.state.appId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 获取视图详情 401
export function actionFetchFormViewOutDetail(store, {companyId, formId, viewId}) {
  return post("/ruyiflow/app/form/view/out/detail/v2", {
    companyId: companyId || store.state.companyId,
    appId: store.state.appId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_MAP', resultObject.memberDetailMap)
      store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalDetailMap)
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}
/** 外链相关接口 */
// 获取外链填写是否需要密码
export function actionLinkPreCheck({state}, formId) {
  return post('/ruyiflow/app/form/out/link/pre/check', {
    formId
  })
}

// 外链填写校验
export function actionTypeVerify({state}, {formId, checkType, password}) {
  return post('/ruyiflow/app/form/out/type/verify', {
    formId, checkType, password
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(`${status}: ${info}`)
    } else {
      return {status, resultObject, info}
    }
  })
}

// 外链填写数据结构
export function actionTypeStructure({state}, formId) {

  const param = {
    formId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/encrypt/out/type/structure', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === 0) {
        return resultObject
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取外链查询是否需要密码
export function actionQueryPreCheck({state}, {formId, queryId}) {
  return post('/ruyiflow/app/form/out/query/pre/check', {
    formId, queryId
  }).then(({status, resultObject, info}) => {
    if (status === 0) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 外链查询校验
export function actionQueryVerify({state}, {formId, queryId, checkType, password}) {
  return post('/ruyiflow/app/form/out/query/verify', {
    formId,
    queryId,
    checkType,
    password
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(`${status}: ${info}`)
    } else {
      return {status, resultObject, info}
    }
  })
}

// 外链查询数据结构
export function actionQueryStructure({state}, {formId, queryId}) {

  const param = {
    formId, queryId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/encrypt/out/query/structure', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === ERROR) {
        throw new Error(`${status}: ${info}`)
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        return {status, resultObject, info}
      }
    })
}

// 外链查询结果
export function actionQueryData({state}, data) {

  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data
    })
  }
  return post('/ruyiflow/app/form/encrypt/out/query/data', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 表单催办
export function actionFormRemind({state}, {appId, companyId, formId, instanceId, stepId}) {
  return post('/ruyiflow/workspace/app/form/apply/remind', {
    userId: state.userId,
    appId,
    companyId,
    formId,
    instanceId,
    stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单预览详情
export function actionFormPreviewDetail({state}, randomId) {
  return post('/ruyiflow/app/form/preview/detail', {
    randomId
  })
}


/**
 * 申请列表-申请待确认成员
 * @param store
 * @param type  {number} 0 全部 1 待处理
 * @returns {Q.Promise<{resultObject, status, info}> | * | Q.Promise<{resultObject, status, info} | never> | Promise<R> | Promise<R|*> | Promise<*> | PromiseLike<{resultObject, status, info} | never>}
 */
export function actionCompanyApplyList(store, type) {
  return post("/ruyiflow/company/apply/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    currentPage: 1,
    pageSize: 100,
    type
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

/**
 * 申请-批量删除
 * @param store
 * @param recordIdList {number[]} 删除申请idList
 * @returns {Q.Promise<{resultObject, status, info}> | * | Q.Promise<{resultObject, status, info} | never> | Promise<R> | Promise<R|*> | Promise<*> | PromiseLike<{resultObject, status, info} | never>}
 */
export function actionCompanyApplyRemove(store, recordIdList) {
  return post("/ruyiflow/company/apply/remove", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    recordIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

/**
 * 申请-处理
 * @param store
 * @param recordId    {number} 申请Id
 * @param applyStatus {number} 1 同意 2 拒绝
 * @returns {Q.Promise<{resultObject, status, info}> | * | Q.Promise<{resultObject, status, info} | never> | Promise<R> | Promise<R|*> | Promise<*> | PromiseLike<{resultObject, status, info} | never>}
 */
export function actionCompanyApplyHandle(store, {recordIdList, applyStatus}) {
  return post("/ruyiflow/company/apply/handle", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    recordIdList,
    applyStatus
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 保存 webview 中需要使用到的数据
export function reqNodeSave(store, nodeValue) {
  return post('/wechat/node/save', {
    // maxUseCount: 3,
    // expireTime: 60,
    maxUseCount: 1000,
    expireTime: 6000000,
    nodeValue
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}

// 获取行业列表
export function actionFetchIndustryList(store) {
  return post("/ruyiflow/app/industry/list", {
    userId: store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

/**
 * 外部联系人列表
 */
export function actionExternalList(store, {userId, companyId, filterLabelList, filterType}) {
  return post("/ruyiflow/external/list", {
    userId: userId || store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    filterLabelList: filterLabelList || [],
    filterType: filterType || 0
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_EXTERNAL_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

/**
 * 外部联系人标签组列表
 */
export function actionLabelGroupList(store, {userId, companyId}) {
  return post("/ruyiflow/label/group/list", {
    userId: userId || store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_EXTERNAL_LABEL_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function actionCompanyList(store, {userId}) {
  return post("/ruyiflow/app/user/company/list", {
    userId: userId || store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_COMPANY_LIST', resultObject)
      const company = resultObject.filter(company => company.companyId === store.getters.currentCompanyId)[0]
      if (company) {
        store.commit('UPDATE__COMPANY', company)
      }
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 创建团队
export function createCompany(store, {companyName, companyDes, companyImage, industry, staffCount}) {
  return post('/ruyiflow/app/user/company/create', {
    userId: store.getters.userId,
    companyName,
    companyDes,
    companyImage,
    industry,
    staffCount
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(info)
    } else {
      return {status, resultObject, info}
    }
  })
}

// 有推荐应用的所有的一级tag
export function actionRecommendTag(store) {
  return post('/ruyiflow/template/tag/recommend', {
    needRecommend: 1
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(`${status}: ${info}`)
    } else {
      return resultObject
    }
  })
}

// tag下的推荐应用
export function actionRecommendTemplate(store, {tagId}) {
  return post('/ruyiflow/template/tag/recommend/template', {
    tagId,
    needRecommend: 1
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(`${status}: ${info}`)
    } else {
      return resultObject
    }
  })
}

//app应用tag获取
export function actionFetchAppTemplateTag(store) {
  return post("/ruyiflow/template/tag/all", {})
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

//app应用获取
export function actionFetchAppTemplate(store, {queryStr, tagIdList, subTagId, currentPage, pageSize}) {
  return post("/ruyiflow/template/query", {
    queryStr,
    tagIdList,
    subTagId,
    currentPage,
    pageSize
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 单个应用详情
export function getTemplateInfo(store, appId) {
  return post("/ruyiflow/template/front/detail", {
    appId,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取表单列表(参数不固定),返回表单list，带表单目录
export function getTemplateForms(store, appId) {
  return post("/ruyiflow/template/form/list", {
    appId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取应用表单结构
export function getTempFormStructure(store, {appId, formId}) {
  const param = {
    appId,
    formId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/template/encrypt/form/structure", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取应用表单详情
export function getTempFormDetail(store, {sectionIdList, fieldIdList, formId, appId}) {
  const param = {
    sectionIdList, fieldIdList, formId, appId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/template/encrypt/form/field/detail", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 保存 webview 中需要使用到的数据
export function actionNodeSave(store, nodeValue) {
  return post('/wechat/node/save', {
    maxUseCount: 3000,
    expireTime: 600000,
    nodeValue
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}


// 获取company列表,带权限字段hasInstallPer
export function reqInstallCompanyList(store) {
  return post('/ruyiflow/user/company/list', {
    userId: store.getters.userId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}

// 注册成功后创建团队，安装实例应用
export function reqInstallDemo(store) {
  return post('/ruyiflow/user/create/company/install/demo', {
    userId: store.getters.userId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}

// 获取申请加入团队的列表
export function getApplyCompanyList(store) {
  return post("/ruyiflow/user/apply/company/list", {
    userId: store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 提醒管理员同意
export function actionCompanyApplyRemind(store, {recordId}) {
  return post('/ruyiflow/user/apply/company/remind', {
    userId: store.getters.userId,
    recordId
  })
}

export function getApps(store) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/ct/home", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 更新app
export function updateApp(store, {appId, appName, appDes, appImg, appIcon, iconColor}) {
  return post("/ruyiflow/app/update", {
    appId,
    appName,
    appDes,
    appImg,
    appIcon,
    iconColor,
    companyId: store.getters.currentCompanyId,
    userId: store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return info
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function getAppDetail(store, {appId}) {
  return post("/ruyiflow/app/show/detail", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取表单列表
export function getForms(store, appId) {
  const param = {
    appId,
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/under/ct/form/list", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取表单视图可见人员 - 列表
export function actionFetchFormViewVisible(store, {appId, formId}) {
  return post("/ruyiflow/app/form/view/visible/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === ERROR) {
      throw new Error(`${status}: ${info}`)
    } else {
      return resultObject
    }
  })
}

// 快速设置权限
export function actionPermissionFastSet(store, {userIdList, depIdList, roleIdList, appSetList}) {
  return post("/ruyiflow/app/form/permission/fast/set", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    userIdList,
    depIdList,
    roleIdList,
    appSetList
  })
}

// 注册补充信息 pathway 0 直接注册 1 邀请 2 应用中心
export function actionRegisterComplete(store, {userId, pathway, appIdList}) {
  return post('/ruyiflow/app/user/register/complete', {
    userId: userId ? userId : store.getters.userId,
    registerType: 1,
    pathway,
    appIdList
  })
}


// 融request节点异步获取数据--mqtt下发数据
export function actionRequestTmpSubmit(store, {companyId, appId, formId, instanceId, rowIdx, fieldId, data, tmpTopic}) {
  return post(`/ruyiflow/app/form/request/tmp/submit`, {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    instanceId,
    rowIdx,
    fieldId,
    data,
    tmpTopic,
    version: Date.now()
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融request获取远端数据
export function actionRequestDataGet(store, {companyId, appId, formId, instanceId, rowIdx, fieldId, data, tmpTopic}) {
  return post(`/ruyiflow/app/form/request/get/data`, {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    instanceId,
    rowIdx,
    fieldId,
    data,
    tmpTopic,
    version: Date.now()
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取视图移动端样式
export function actionFormDataPhoneStyleGet(store, {appId, formId, viewId}) {
  return post("/ruyiflow/app/form/view/mobile/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取视图移动端样式-免401
export function actionFormDataPhoneStyleOutGet(store, {companyId, appId, formId, viewId}) {
  return post("/ruyiflow/app/form/view/out/mobile/get", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 获取数据筛选下拉数据源
export function actionFetchFilterDataSourceList(store, {appId, companyId, formId, fieldId, dataSourceType, conditionList}) {
  return post('/ruyiflow/app/form/apply/filter/data', {
    userId: store.getters.userId,
    appId,
    companyId,
    formId,
    fieldId,
    dataSourceType: dataSourceType || 0,  // 筛选联动的数据源表单类型 0流程表单， 1 聚合表
    conditionList: conditionList || [],  // 筛选联动的过滤条件
    pageSize: 1000
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 用户权限
export function actionFetchUserPermission(store) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/all/permission', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        store.commit('UPDATE_ADMIN', resultObject)
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

export function actionCompanyWaitHandleMember(store) {
  return post("/ruyiflow/company/wait/handle", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 我的页面获取文章和轰动list
export function actionFetchActivityList(store) {
  return post("/themis/miniapp/page/front", {
    userId: store.getters.userId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

// 获取app首页页面配置
export function actionFetchAppHomeConfig(store, appId) {
  return post("/ruyiflow/app/custom/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

// app描述
export function actionFetchAPPDes(store, appId) {
  return post("/ruyiflow/app/intro/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
  })
      .then(({status, resultObject, info}) => {
        if (status === SUCCESS) {
          return resultObject
        } else {
          throw new Error(`${status}: ${info}`)
        }
      })
}

export function actionFetchCustomForms(store, {appId, showFormType}) {
  return post("/ruyiflow/app/custom/form/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    showFormType
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

//阅读完成
export function finishRead(store, {appId, readMap}) {
  return post("/ruyiflow/app/intro/read/record", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    readFinish:"YES",
    readMap: readMap,
    appId,
  })
      .then(({status, resultObject, info}) => {
        if (status === SUCCESS) {
          return resultObject
        } else {
          throw new Error(`${status}: ${info}`)
        }
      })
}
// 获取我的待办、抄送。。。红点
export function actionFormHandleNumber(store, {appId, formId}) {
  return post('/ruyiflow/workspace/self/handle/number', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取我的待办头部list
export function actionFetchTodoFilterList(store, {appId}) {
  return post("/ruyiflow/workspace/todo/filter/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId ? appId : store.getters.currentAppId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 快捷筛选结果
export function actionFetchTodoFilterData(store, {appId, recordId, sort, currentPage, pageSize}) {
  return post("/ruyiflow/workspace/todo/filter/data", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    recordId,
    sort,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取工作台我的待办表单列表
export function actionFetchTodoFormList(store, {
  companyId,
  appId,
  formId,
  stepId,
  sort,
  remindFlag,
  timeoutFlag,
  preRemindFlag,
  filterUser,
  filterTime,
  currentPage,
  pageSize
}) {
  console.log('currentPage', currentPage)
  return post("/ruyiflow/workspace/todo", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    sort,
    remindFlag,
    timeoutFlag,
    preRemindFlag,
    filterUser,
    filterTime,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取工作台我发起的表单列表
export function actionFetchCreateFormList(store, {companyId, appId, formId, stepId, sort, filterFlowState, filterTime, currentPage, pageSize}) {
  return post("/ruyiflow/workspace/create", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    sort,
    filterTime,
    filterFlowState,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取工作台我处理过的表单列表
export function actionFetchHandleFormList(store, {companyId, appId, formId, stepId, sort, filterUser, filterTime, filterFlowState, currentPage, pageSize}) {
  return post("/ruyiflow/workspace/handle", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    sort,
    filterUser,
    filterTime,
    filterFlowState,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取工作台抄送给我的表单列表
export function actionFetchCcFormList(store, {companyId, appId, formId, stepId, sort, filterUser, filterTime,
  filterFlowState, currentPage, pageSize, ccUnread}) {
  return post("/ruyiflow/workspace/cc", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    sort,
    filterUser,
    filterTime,
    filterFlowState,
    currentPage,
    pageSize,
    ccUnread
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取工作台暂存表单列表
export function actionFetchDraftFormList(store, {companyId, appId, formId, stepId, sort, filterUser, filterTime, currentPage, pageSize}) {
  return post("/ruyiflow/workspace/tmp", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    sort,
    filterUser,
    filterTime,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 星标app
export function actionStarApp(store, {appId}) {
  return post("/ruyiflow/app/star", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

// 取消星标app
export function actionCancelStarApp(store, {appId}) {
  return post("/ruyiflow/app/star/cancel", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status} ${info}`)
      }
    })
}

// 工作台tab
export function actionWorkspaceTabList(store) {
  return post("/ruyiflow/workspace/tab/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 工作台tab
export function actionWorkspaceNewTabList(store) {
  return post("/ruyiflow/workspace/tab/list_new", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

/**
 * 工作台tab数据
 */
export function actionWorkspaceTabData(store, {
  id,
  appId,
  formId,
  stepId,
  sort,
  remindFlag,
  timeoutFlag,
  preRemindFlag,
  filterUser,
  filterTime,
  filterFlowState,
  currentPage,
  pageSize,
  ccUnread
}) {
  return post("/ruyiflow/workspace/tab/data", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    id,
    appId,
    formId,
    stepId,
    sort,
    remindFlag,
    timeoutFlag,
    preRemindFlag,
    filterUser,
    filterTime,
    filterFlowState,
    currentPage,
    pageSize,
    ccUnread
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 星标表单
export function actionFormStar(store, {formId}) {
  return post("/ruyiflow/app/form/star", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    formId
  })
}

// 星标表单取消
export function actionFormStarCancel(store, {formId}) {
  return post("/ruyiflow/app/form/star/cancel", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    formId
  })
}

// 星标表单list
export function actionFormStarList(store) {
  return post("/ruyiflow/app/form/star/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 图片控件上传图片
export function actionFieldImageUpload(store, {formId, topic, fieldId, subTable, rowIdx, mediaIdList}) {
  return post("/ruyiflow/app/form/apply/upload/image", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: store.getters.currentAppId,
    formId,
    topic,
    fieldId,
    subTable,
    rowIdx,
    mediaIdList,
    zjConfig: store.getters.env === ENV_TYPE_WXWORK_ZJ ? 'YES' : 'NO',
    version: Date.now()
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 手机上传图片，web端显示
export function actionImageUploadQrcode(store, {formId, topic, fieldId, subTable, rowIdx, imageList, taskId}) {
  return post("/ruyiflow/app/form/apply/upload/image/qrcode", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: store.getters.currentAppId,
    formId,
    topic,
    fieldId,
    subTable,
    rowIdx,
    imageList,
    taskId,
    version: Date.now()
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 手机上传图片，web端显示（项目中使用）
export function actionMixFormImageUploadQrcode(store, {topic, imageList}) {
  return post("/ruyiflow/mix_form/image/upload", {
    topic,
    imageList,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 手写签名上传
export function actionSignUpload(store, {formId, topic, fieldId, taskId, subTable, rowIdx, signatureInfo, saveSignature}) {
  return post("/ruyiflow/app/form/apply/signature/upload", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: store.getters.currentAppId,
    formId,
    topic,
    fieldId,
    taskId,
    subTable,
    rowIdx,
    signatureInfo,
    saveSignature
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 给指定团队安装应用
export function actionInstallTemplate(store, {userId, companyId, appIdList, installData}) {
  return post('/ruyiflow/user/install/company/template', {
    userId,
    companyId,
    appIdList,
    installData
  })
    .then(res => {
      if (!res) {
        res = {
          status: 500180001,
          resultObject: null,
          info: '权益不足'
        }
      }
      return res
    })
}

// 查询应用是否安装成功
export function actionInstallTemplateResult(store, {userId, companyId, taskIdList}) {
  return post('/ruyiflow/user/template/install/result', {
    userId,
    companyId,
    taskIdList
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}

// 获取用户是否有签名文件
export function actionFormLastSignatureGet(store) {
  return post("/ruyiflow/app/form/apply/signature/get", {
    userId: store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据动态
export function actionFetchFormDataDynamic(store, {companyId, appId, formId, instanceId}) {
  return post("/ruyiflow/app/form/apply/dynamic", {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

export function actionFetchFormDataLinkDynamic(store, {companyId, appId, formId, instanceId}) {
  return post("/ruyiflow/app/form/out/apply/dynamic", {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 审批意见列表
export function actionFetchFormApproveComment(store, {companyId, appId, formId, instanceId}) {
  return post("/ruyiflow/app/form/apply/approve/comment", {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

export function actionFetchFormApproveLinkComment(store, {companyId, appId, formId, instanceId}) {
  return post("/ruyiflow/app/form/out/apply/approve/comment", {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 获取审批意见签名轮训的KEY
export function actionApprovalCommentKey(store, {cycleType}) {
  return post("/ruyiflow/cycle/get/key", {
    userId: store.getters.userId,
    cycleType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取审批意见签名轮训的KEY
export function actionApprovalCommentSignResult(store, {taskId}) {
  return post("/ruyiflow/cycle/get/result", {
    userId: store.getters.userId,
    taskId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据删除
export function actionBatchDelete(store, {instanceIdList, formId, appId, viewId, viewGroupId, operateId, refreshType}) {
  return post('/ruyiflow/app/form/apply/batch/delete', {
    userId: store.getters.userId || '',
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId,
    instanceIdList,
    viewGroupId,
    operateId,
    refreshType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`/file/upload ${status}: ${info}`)
    }
  })
}

// 表单视图数据删除
export function actionViewBatchDelete(store, {instanceIdList, formId, appId, viewId, viewGroupId, operateId, refreshType}) {
  return post('/ruyiflow/app/form/apply/view/batch/delete', {
    userId: store.getters.userId || '',
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId,
    instanceIdList,
    viewGroupId,
    operateId,
    refreshType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`/file/upload ${status}: ${info}`)
    }
  })
}

// 获取打印模板list
export function actionFetchFormPrintTempList(store, {formId, appId}) {
  return post('/ruyiflow/app/form/print/template/list', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    formId,
    appId,
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 系统打印的结构数据
export function actionPrintTempList(store, {companyId, appId, formId, dataId, scopeType}) {
  return post("/ruyiflow/app/form/system/print/template/all", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    dataId,
    scopeType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 批量打印模板
export function actionFormBatchPrintTemp(store, {formId, appId, viewId, itemId, instanceIdList}) {
  return post('/ruyiflow/app/form/apply/batch/print', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    formId,
    appId,
    viewId,
    itemId,
    instanceIdList
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 单个打印
export function actionFormLinkPrintTemp(store, {companyId, formId, appId, itemId, instanceId}) {
  return post('/ruyiflow/app/form/apply/print', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    formId,
    appId,
    itemId,
    instanceId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 校验表单是否有填写权限
export function actionFormFillPermission(store, {appId, formId}) {
  return post("/ruyiflow/app/form/check/type", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取点击自定义按钮表单填充数据
export function actionViewButtonApplyData(store, {appId, formId, viewId, instanceId, buttonId}) {
  return post(`/ruyiflow/app/form/view/button/apply/data`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    instanceId,
    buttonId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 设置用户表单设置
export function actionSetFormUserCustom(store, {appId, formId, saveCreateNext, saveCurrentData}) {
  return post(`/ruyiflow/app/form/user/custom/set`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    saveCreateNext, // 保存后继续创建下一条
    saveCurrentData // 保留当前内容
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取用户表单设置
export function actionFetchFormUserCustom(store, {appId, formId}) {
  return post(`/ruyiflow/app/form/user/custom/get`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 打印模板结果查询
export function actionFetchExcelPrintProgressQuery(store, {companyId, exportId}) {
  return post('/ruyiflow/resource/form/print/query', {
    companyId: companyId || store.getters.currentCompanyId,
    exportId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单提交的value详情(外链)
export function actionFetchLinkFormViewDataDetail(store, {companyId, formId, instanceId}) {
  return post("/ruyiflow/app/form/apply/instance/out/detail", {
    companyId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}

// 插件数据提交
export function actionApplyPluginSubmit(store, {companyId, appId, formId, instanceId, fieldId, entryId, rowIdx, data, tmpTopic, context}) {
  return post('/ruyiflow/app/form/apply/plugin/submit', {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    fieldId,
    entryId,
    rowIdx,
    data,
    tmpTopic,
    context,
    instanceId,
    version: Date.now()
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else if (status !== ERROR && info) {
        this._vm.$toast.fail(info)
      } else {
        this._vm.$toast.fail('请求失败')
        throw new Error(`${status}: ${info}`)
      }
    })
}


// 客户门户详情
export function actionSpaceGuideGet(store, {spaceId}) {
  return axios.post('/qmf/agent/guide/config/get', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    spaceId,
  }).then((res) => {
	  let {code,msg,result} = res.data;
	  if (code === SUCCESS) {
	    return result
	  } else if (code !== ERROR && msg) {
	    this._vm.$toast.fail(msg)
	    throw new Error(`${code}: ${msg}`)
	  } else {
	    this._vm.$toast.fail('请求失败')
	    throw new Error(`${code}: ${msg}`)
	  }
  })
}

// 客户门户引导页详情
export function actionSpaceDetail(store, {spaceId}) {
  return post('/ruyiflow/client/space/detail', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    spaceId,
    needConfigDetail: 1
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 客户门户页面配置信息详情
export function actionSpacePageConfigDetail(store, {spaceId, pageConfigId}) {
  return post('/ruyiflow/client/space/page/config/detail', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    spaceId,
    pageConfigId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取门户数据详情数据
export function actionSpaceApplyData(store, {appId, formId, viewId, filterInfo, sortList}) {
  return post('/ruyiflow/app/form/apply/space/filter', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    filterInfo,
    sortList
  })
}

// 客户门户页面配置信息详情
export function actionSpaceRemoveBinding(store) {
  return post('/ruyiflow/api/user/unbinding', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 飞书应用卸载
export function actionLarkAppRemove(store, {tenantKey}) {
  return post('/wxscrm/lark/app/uninstall', {
    tenantKey
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 飞书解绑并退出团队
export function actionLarkUnbinding(store, {userId, companyId}) {
  return post('/wxscrm/lark/unbinding', {
    userId,
    companyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 文件预览地址
export function actionFilePreviewUrl(store, {previewFile}) {
  return post("/ruyiflow/online/preview/url/v2", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    previewFile
  })
}
// 文件预览地址
export function actionFilePreviewOutUrl(store, {fileUrl, ipInfo}) {
  return post("/ruyiflow/online/preview/out_url", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    fileUrl,
    ipInfo
  })
}


// 分组信息保存
export function actionMixFormGroupSave(store, {groupName}) {
  return post("/ruyiflow/mix_form/group/save", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    groupName
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 分组信息更新
export function actionMixFormGroupUpdate(store, {groupId, groupName}) {
  return post("/ruyiflow/mix_form/group/update", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    groupId,
    groupName
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 分组信息删除
export function actionMixFormGroupDelete(store, {groupId}) {
  return post("/ruyiflow/mix_form/group/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    groupId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 分组列表
export function actionMixFormGroupList(store) {
  return post("/ruyiflow/mix_form/group/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 分组排序
export function actionMixFormGroupSort(store, {sortedIdList}) {
  return post("/ruyiflow/mix_form/group/sort", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    sortedIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 新增融合表
export function actionMixFormCreate(store, {mixFormName, groupIdList, chargeUser, participant, processType}) {
  return post("/ruyiflow/mix_form/save", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormName,
    groupIdList,
    chargeUser,
    participant,
    processType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 更新融合表
export function actionMixFormUpdate(store, {mixFormId, mixFormName, groupIdList, chargeUser, participant, processType}) {
  return post("/ruyiflow/mix_form/update", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    mixFormName,
    groupIdList,
    chargeUser,
    participant,
    processType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表列表
export function actionMixFormList(store, {listType, groupIdList, currentPage, pageSize, keyWords, status, archived}) {
  return post("/ruyiflow/mix_form/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    listType,
    groupIdList,
    currentPage,
    pageSize,
    keyWords,
    status,
    archived
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 删除融合表
export function actionMixFormDelete(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表回收站列表
export function actionMixFormRecycleList(store, {currentPage, pageSize, keyWords}) {
  return post("/ruyiflow/mix_form/recycle/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    currentPage,
    pageSize,
    keyWords
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 回收站删除融合表
export function actionMixFormRecycleDelete(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/recycle/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 回收站恢复数据
export function actionMixFormRecycleRecover(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/recycle/recover", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 新建目录
export function actionMixFormNodeCreate(store, opts) {
  const {
    mixFormId,
    parentId, //根节点为空,
    sortIndex, //排序
    nodeName, //目录名称
    nodeContent,
    attachmentList,
    nodeColor,
    nodeIcon,
    chargeUser, //负责人
    participant,
    showImage,
    viewByMixForm //融合表参与人可查看此目录
  } = opts
  return post("/ruyiflow/mix_form/node/save", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    parentId, //根节点为空,
    sortIndex, //排序
    nodeName, //目录名称
    nodeContent,
    attachmentList,
    nodeColor,
    nodeIcon,
    chargeUser, //负责人
    participant,
    showImage,
    viewByMixForm //融合表参与人可查看此目录
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 更新目录
export function actionMixFormNodeUpdate(store, opts) {
  const {
    mixFormId,
    nodeId,
    parentId, //根节点为空,
    sortIndex, //排序
    nodeName, //目录名称
    nodeContent,
    attachmentList,
    nodeColor,
    nodeIcon,
    chargeUser, //负责人
    participant,
    showImage,
    viewByMixForm //融合表参与人可查看此目录
  } = opts
  return post("/ruyiflow/mix_form/node/update", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    parentId, //根节点为空,
    sortIndex, //排序
    nodeName, //目录名称
    nodeContent,
    attachmentList,
    nodeColor,
    nodeIcon,
    chargeUser, //负责人
    participant,
    showImage,
    viewByMixForm //融合表参与人可查看此目录
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 目录详情
export function actionMixFormNodeDetail(store, {mixFormId, nodeId}) {
  return post("/ruyiflow/mix_form/node/detail", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 目录删除
export function actionMixFormNodeDelete(store, {mixFormId, nodeId}) {
  return post("/ruyiflow/mix_form/node/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 新增挂载
export function actionMixFormNodeItemAdd(store, {mixFormId, nodeId, itemType, itemImage, sortIndex, itemDetail}) {
  return post("/ruyiflow/mix_form/node/item/add", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    itemType,
    itemImage,
    sortIndex,
    itemDetail
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 更新挂载
export function actionMixFormNodeItemUpdate(store, {mixFormId, nodeId, itemId, itemType, itemImage, sortIndex, itemDetail}) {
  return post("/ruyiflow/mix_form/node/item/update", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    itemId,
    itemType,
    itemImage,
    sortIndex,
    itemDetail
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 挂载删除
export function actionMixFormNodeItemDelete(store, {mixFormId, nodeId, itemId}) {
  return post("/ruyiflow/mix_form/node/item/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    itemId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 挂载详情
export function actionMixFormNodeItemDetail(store, {mixFormId, nodeId, itemId}) {
  return post("/ruyiflow/mix_form/node/item/detail", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    itemId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 目录挂载列表
export function actionMixFormNodeItemList(store, {mixFormId, nodeId}) {
  return post("/ruyiflow/mix_form/node/item/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表概览
export function actionMixFormOverview(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/overview", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表归档,启用
export function actionMixFormArchived(store, {mixFormId, archived}) {
  return post("/ruyiflow/mix_form/archived", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    archived
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 目录列表
export function actionMixFormNodeList(store, {mixFormId, parentId}) {
  return post("/ruyiflow/mix_form/node/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    parentId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表置顶,取消置顶
export function actionMixFormTop(store, {mixFormId, top}) {
  return post("/ruyiflow/mix_form/top", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    top
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据权限
export function actionFormDataPermission(store, {appId, formId}) {
  return post("/ruyiflow/mix_form/form/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 发起表单数据权限
export function actionFormApplyDetailPermission(store, {appId, formId, instanceId}) {
  return post("/ruyiflow/mix_form/form/apply/detail/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单视图权限
export function actionFormViewPermission(store, {appId, formId, viewId}) {
  return post("/ruyiflow/mix_form/form/view/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 仪表盘权限
export function actionDashboardPermission(store, {appId, dashboardId}) {
  return post("/ruyiflow/mix_form/dashboard/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    dashboardId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表权限
export function actionMixFormPermission(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据状态
export function actionFormStatus(store, {instanceIdList}) {
  return post("/ruyiflow/mix_form/apply/status", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单申请查看权限（没有找到返回null 需要找到我发起的 我的待办 抄送给我的 我参与的）
export function actionFormApplyViewCheck(store, {instanceId}) {
  return post("/ruyiflow/mix_form/apply/handle/info", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 文件预览历史
export function actionFilePreviewHistory(store, {fileUrl}) {
  return post("/ruyiflow/online/preview/history", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    fileUrl
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表添加评论
export function actionMixFormCommentAdd(store, opts) {
  const {
    mixFormId,
    nodeId, //目录Id
    itemId, //挂载Id
    commentType, //NODE 目录 ITEM 挂载 INSTANCE 表单
    rootId,
    replyId,
    content,
    attachmentList,
    noticeCharge, //通知负责人
    noticePart // 通知参与人
  } = opts
  return post("/ruyiflow/comment/mix_form/add", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId,
    itemId,
    commentType,
    rootId,
    replyId,
    content,
    attachmentList,
    noticeCharge,
    noticePart
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据添加评论
export function actionFormDataCommentAdd(store, opts) {
  const {
    instanceId,
    commentType, //NODE 目录 ITEM 挂载 INSTANCE 表单
    rootId,
    replyId,
    content,
    attachmentList,
    noticeUser
  } = opts
  return post("/ruyiflow/comment/apply/add", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId,
    commentType,
    rootId,
    replyId,
    content,
    attachmentList,
    noticeUser
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论列表
export function actionCommentList(store, {mixFormId, nodeId, itemId, instanceId, commentType}) {
  return post("/ruyiflow/comment/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId, // 融合表传
    nodeId, // NODE 目录 ITEM 挂载 传
    itemId, //  ITEM 挂载 传
    instanceId, // INSTANCE 表单时传
    commentType //NODE 目录 ITEM 挂载 INSTANCE 表单
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论订阅关系获取
export function actionCommentSubscribeGet(store, {instanceId}) {
  return post("/ruyiflow/comment/apply/subscribe/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论订阅关系设置  subscribe: OPEN 打开订阅 CLOSE 关闭订阅
export function actionCommentSubscribeChange(store, {instanceId, subscribe}) {
  return post("/ruyiflow/comment/apply/subscribe/change", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId,
    subscribe
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论订阅关系人员列表
export function actionCommentSubscribeList(store, {instanceId}) {
  return post("/ruyiflow/comment/apply/subscribe/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论订阅关系人员列表设置
export function actionCommentSubscribeListSet(store, {instanceId, subscribeUserList}) {
  return post("/ruyiflow/comment/apply/subscribe/set", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId,
    subscribeUserList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论订阅关系人员列表设置
export function actionCommentSubscribeRemove(store, {instanceId, removeUserIdList}) {
  return post("/ruyiflow/comment/apply/subscribe/remove", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId,
    removeUserIdList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 回复的列表
export function actionCommentReplyList(store, {commentId, rootId}) {
  return post("/ruyiflow/comment/reply/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    commentId,
    rootId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论的删除
export function actionCommentDelete(store, {commentId, rootId}) {
  return post("/ruyiflow/comment/delete", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    commentId,
    rootId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 评论的编辑
export function actionCommentUpdate(store, {commentId, content, attachmentList, atUserList}) {
  return post("/ruyiflow/comment/update", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    commentId,
    content,
    attachmentList,
    atUserList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单添加评论 commentType NODE 目录 ITEM 挂载 INSTANCE 表单.. commentLocation 评论的位置 view 视图 DATA 管理数据 FLOW 流程
export function actionFormCommentAdd(store, {instanceId, commentType, rootId, replyId, content, attachmentList, commentLocation, viewId, stepId, atUserList}) {
  return post("/ruyiflow/comment/apply/add", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId,
    commentType,
    rootId,
    replyId,
    content,
    attachmentList,
    commentLocation,
    viewId,
    stepId,
    atUserList
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表目录的移动
export function actionMixFormNodeMove(store, {mixFormId, targetMixFormId, nodeId, moveNodeId, moveType}) {
  return post("/ruyiflow/mix_form/node/move", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    targetMixFormId,
    nodeId,
    moveNodeId,
    moveType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表目录的复制
export function actionMixFormNodeCopy(store, {mixFormId, targetMixFormId, nodeId, moveNodeId, moveType}) {
  return post("/ruyiflow/mix_form/node/copy", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    targetMixFormId,
    nodeId,
    moveNodeId,
    moveType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表挂载的移动
export function actionMixFormNodeItemMove(store, {mixFormId, targetMixFormId, itemId, moveNodeId, moveItemId, moveType}) {
  return post("/ruyiflow/mix_form/node/item/move", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    targetMixFormId,
    itemId,
    moveNodeId,
    moveItemId,
    moveType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 融合表挂载的复制
export function actionMixFormNodeItemCopy(store, {mixFormId, targetMixFormId, itemId, moveNodeId, moveItemId, moveType}) {
  return post("/ruyiflow/mix_form/node/item/copy", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    targetMixFormId,
    itemId,
    moveNodeId,
    moveItemId,
    moveType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 消息
export function actionMixFormMqttConfigGet(store, {mixFormId}) {
  return post("/ruyiflow/mix_form/mqtt/config/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 项目置顶列表
export function actionMixFormTopList(store) {
  return post("/ruyiflow/mix_form/top/list", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 接收项目上传图片消息
export function actionMixFormUploadImageMqttConfigGet(store, {mixFormId, nodeId}) {
  return post("/ruyiflow/mix_form/mqtt/upload/config/get", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    mixFormId,
    nodeId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function ImageUploadToServer(store, {topic, mediaIdList}) {
  return post("/ruyiflow/mix_form/wechat/image/upload", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    topic,
    mediaIdList,
    zjConfig: store.getters.env === ENV_TYPE_WXWORK_ZJ ? 'YES' : 'NO'
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取广告公告List
export function actionAdvertisingList(store) {
  return post("/ruyiflow/advertising/front/list", {
    userId: store.getters.userId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 广告已读
export function actionAdvertisingRead(store, {recordId}) {
  return post("/ruyiflow/advertising/front/read", {
    userId: store.getters.userId,
    recordId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 版本检测
export function actionLevelCheck(store) {
  return post('/ruyiflow/company/level/check', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 活跃人数数据保存
export function actionStatisticsUser(store) {
  return post('/ruyiflow/statistics/user/create', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 活跃人数数据保存
export function actionAppOperationStatistics(store, {operationType, appId}) {
  return post('/ruyiflow/statistics/operation/create', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    operationType,
    appId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取表单实时数据控件的值
export function actionFormRealTimeDataFieldData(store, {companyId, appId, formId, data}) {
  return post(`/ruyiflow/app/form/apply/real_time_data`, {
    userId: store.getters.userId,
    companyId: companyId ? companyId : store.getters.currentCompanyId,
    appId,
    formId,
    data
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail('非常抱歉，程序开小差了，请联系在线客服')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取人员所属部门、角色、外部联系人tag信息
export function actionMemberInfo(store, {companyId, userIdList}) {
  return post('/ruyiflow/company/member/info/batch/get', {
    companyId,
    userIdList
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}


// 收银台信息
export function actionCompanyPaymentApplyOrderDetail(store, {orderId}) {
  return post('/ruyiflow/company/payment/apply/order/detail', {
    userId: store.getters.userId,
    orderId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 订单支付成功后跳转信息
export function actionCompanyPaymentApplyOrderJumpInfo(store, {orderId}) {
  return post('/ruyiflow/app/form/apply/pay/success/jump/get', {
    userId: store.getters.userId,
    orderId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 订单也点击支付方式-预支付的接口
export function actionCompanyPaymentApplyOrderPerPay(store, {orderId, payWay, mobile, openId}) {
  return post('/ruyiflow/company/payment/apply/order/pre_pay', {
    userId: store.getters.userId,
    orderId, payWay, mobile, openId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取支付结果-轮训前端轮训
export function actionCompanyPaymentApplyOrderResult(store, {orderId}) {
  return post('/ruyiflow/company/payment/apply/order/result', {
    userId: store.getters.userId,
    orderId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 重新支付
export function actionCompanyPaymentApplyOrderRetry(store, {orderId}) {
  return post('/ruyiflow/company/payment/apply/order/retry', {
    userId: store.getters.userId,
    orderId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 重新支付
export function actionPaymentOauthUrl(store, {companyId, nodeKey}) {
  return post('/ruyiflow/company/payment/oauth_url', {
    companyId,
    nodeKey
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取订单数据
export function actionCompanyPaymentApplyOrderPreCreate(store, {appId, formId, data, stepId}) {
  return post('/ruyiflow/company/payment/apply/order/pre_create', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId, formId, data, stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 单个流程节点信息
export function actionCompanyPaymentApplyFlowDetail(store, {appId, formId, stepId}) {
  return post('/ruyiflow/company/payment/apply/flow/detail', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId, formId, stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取节点支付信息接口
export function actionCompanyPaymentApplyOrderCreate(store, {companyId, appId, formId, instanceId, stepId}) {
  return post('/ruyiflow/company/payment/apply/order/create', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId, formId, instanceId, stepId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 团队支付列表
export function actionCompanyPaymentList(store, opts) {
  const {
    userId = store.getters.userId,
    companyId = store.getters.currentCompanyId,
    selfFlag = 0,
    //筛选条件,可穿空
    orderId,  //订单号筛选 选填
    appId,  //应用筛选 选填
    formId, //表单筛选 选填
    startTime,  //下单时间筛选 选填
    endTime, //下单时间筛选 选填
    payWay, //WEI_CHAT_PAY 微信支付 支付方式筛选 选填
    openId, //微信 openId 筛选
    orderStatus, // NONE 未支付 WAIT 待支付 FINISH 已支付 TIMEOUT 超时  CLOSE 已关闭  REFUNDED 已退款 订单状态筛选
    //分页信息
    currentPage, //第几页
    pageSize  //每页多少条
  } = opts
  return post('/ruyiflow/company/payment/list', {
    userId,
    companyId,
    selfFlag,
    orderId,
    appId,
    formId,
    startTime,
    endTime,
    payWay,
    openId,
    orderStatus,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 手动关闭
export function actionCompanyPaymentApplyOrderClose(store, {orderId}) {
  return post('/ruyiflow/company/payment/apply/order/close', {
    userId: store.getters.userId,
    orderId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 流程详情获取一个支付列表
export function actionCompanyPaymentApplyList(store, {instanceId}) {
  return post('/ruyiflow/company/payment/apply/list', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    instanceId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取用户的默认回复信息
export function actionFetchUserDefaultReply(store) {
  return post("/ruyiflow/user/default/reply/get", {
    userId: store.getters.userId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单公式计算下发消息错误上传
export function actionFormMsgErrorUpload(store, {companyId, appId, formId, traceId, errorType, deviceType, scene, costTime}) {
  return post('/ruyiflow/app/form/apply/out_of_order/upload', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    traceId,
    errorType,
    deviceType,
    scene,
    costTime
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取是否去logo
export function actionCompanyLogoConfig(store, {companyId}) {
  return post('/ruyiflow/company/logo/config/get', {
    companyId,
    userId: store.getters.userId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}


// 客户门户场景配置信息详情
export function actionSpaceSceneConfigDetail(store, {sceneId}) {
  return post('/ruyiflow/client/space/scene/detail', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    sceneId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail('请求失败')
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 数据来源控件远程搜索数据
export function actionExternalSearchData(store, {companyId, appId, formId, fieldId, data, rowIdx, queryStr, currentPage, pageSize}) {
  return post('/ruyiflow/app/form/apply/external/data/search', {
    userId: store.getters.userId,
    companyId,
    appId,
    formId,
    fieldId,
    data,
    rowIdx,
    queryStr,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 上传文件获取token
export function actionUploadFileCall(store, {fileKey}) {
  return post('/fs/file/upload/call', {
    fileKey
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`/file/upload ${status}: ${info}`)
    }
  })
}

// 快捷筛选结果
export function actionApplyBatchHandle(store, {handleInstanceList, handleAction}) {
  return post("/ruyiflow/app/form/apply/batch/handle", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    handleInstanceList,
    handleAction
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 级联选择获取数据--本表关联
export function actionFormCascadeLocalData(store, {companyId, appId, formId, relateFieldId, instanceIdList, firstLevel}) {
  return post('/ruyiflow/app/form/cascade/local/data', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId ? appId : store.getters.currentAppId,
    formId,
    relateFieldId,
    instanceIdList,
    firstLevel
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 级联选择获取数据--多表关联
export function actionFormCascadeRemoteData(store, {companyId, appId, formId, relateFieldId, instanceIdList, requestLevel}) {
  return post('/ruyiflow/app/form/cascade/remote/data', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId ? appId : store.getters.currentAppId,
    formId,
    relateFieldId,
    instanceIdList,
    requestLevel
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 表单数据归档 archiveType CHOOSE 选中 ALL 全部, dataType DATA 管理数据 VIEW 视图，handleType ARCHIVE 归档 UNARCHIVE 移除归档
export function actionBatchArchive(store, {archiveType, instanceIdList, dataType, formId, appId, viewId, handleType}) {
  return post('/ruyiflow/app/form/apply/archive/batch/change', {
    userId: store.getters.userId || '',
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    archiveType,
    formId,
    dataType,
    viewId,
    instanceIdList,
    handleType
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取 guest 临时 token
export function actionGuestTokenGet(store, {expireAfter}) {
  return post('/ruyiflow/token/tmp/get', {
    expireAfter
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      if (resultObject.tmpToken) {
        store.commit('UPDATE__TOKEN', resultObject.tmpToken)
        axios.defaults.headers['x-apaas-authorization'] = resultObject.tmpToken
      }
      if (resultObject.userId) store.commit('UPDATE__USER_ID', resultObject.userId)
      if (resultObject.userInfo) store.commit('UPDATE__USER_INFO', resultObject.userInfo)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      this._vm.$router.push({
        name: 'error',
        query: {
          info: JSON.stringify({
            code: status,
            info: info
          })
        }
      })
      throw new Error(`${status}: ${info}`)
    }
  })
}

// qrcode兑换详情信息
export function actionDecodeMiniQr(store, code) {
  return post('/qrcode/detail', {
    qrcodeId: code
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// qrcode兑换一码通详情信息，一码通消息插件发消息后，点击进入详情页面获取的一码通
export function actionQrcodeMsgDetail(store, {qrcodeId, needFile}) {
  return post('/resource/data/qrcode/msg/detail', {
    qrcodeId,
    needFile
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

export function actionResourceSummary(store, {companyId}) {
  return post('/resource/company/summary', {
    companyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 记录登录
export function actionUserLoginRecord(store) {
  return post('/ruyiflow/app/user/login/record', {
    userId: store.getters.userId,
    agentType: 'MINIAPP'
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 成员控件获取动态选人
export function actionDynamicChooseMemberGet(store, {appId, formId,fieldId,ruleKey,data}) {
  return post('/ruyiflow/company/dynamic/choose/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    ruleKey,
    data
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 获取团队组织架构信息
export function getCompanyOrganization(store) {
  return post("/ruyiflow/company/dep/merge/info", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    needHandle: 'NO'
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_LIST', resultObject.memberList)
      store.commit('UPDATE_ORGANIZATION', resultObject.depInfo)
      store.commit('UPDATE_EXTERNAL_LIST', resultObject.externalList)
      store.commit('UPDATE_EXTERNAL_LABEL_LIST', resultObject.labelGroupList)
      store.commit('UPDATE_ROLE_LIST', resultObject.roleList)
      store.commit('UPDATE_LEAVE_MEMBER_LIST', resultObject.leaveMemberList)
      store.commit('UPDATE_LEAVE_EXTERNAL_LIST', resultObject.leaveExternalList)
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 批量获取一码通数据
export function actionBatchPrintDataGet(store, {
  appId,
  printType,
  formId,
  viewId,
  instanceIdList,
  filterInfo
}) {
  return post('/ruyiflow/app/form/apply/view/batch/print/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    printType,
    formId,
    viewId,
    instanceIdList,
    filterInfo,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取二维码数据信息
export function actionQrcodeGenerate(store, posterData) {
  return post('/resource/qrcode/generate', {
    ...posterData
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 子表单数据加载数据获取
export function actionFormSubTableDataFetch(store, {formId, tableId, data, searchStr,key, currentPage, pageSize}) {
  return post('/ruyiflow/app/form/apply/table/load/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: store.getters.currentAppId,
    formId,
    tableId,
    key,
    data, //当前数据信息
    searchStr, //检索 预留 有搜索功能 分页数据不生效 最多返回200条
    currentPage,
    pageSize
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 子表单加载数据提交计算
export function actionFormSubTableDataSubmit(store, {formId, tableId, data, tmpTopic, version}) {
  return post('/ruyiflow/app/form/apply/table/load/submit', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: store.getters.currentAppId,
    formId,
    tableId,
    data, //当前数据信息
    tmpTopic, //检索 预留 有搜索功能 分页数据不生效 最多返回200条
    version
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 子表单加载数据提交计算
export function actionPrintSuccessUpdateData(store, {appId, formId, viewId, recordId, instanceIdList}) {
  return post('/ruyiflow/app/form/view/print/success/update', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    recordId, //当前数据信息
    instanceIdList
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

export function actionGetRealIp(store) {
  return post('/form/api/real/ip', {})
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
export function actionPrintPdfResultGet(store, {companyId, appId, formId, viewId, templateId, instanceId, needType}) {
  return post('/ruyiflow/print/pdf/template/instance/mobile/get', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    templateId, //当前数据信息
    instanceId,
    needType
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// word打印
export function actionFormDataBatchWordPrint(store, {appId, formId, viewId, templateId, instanceIdList}) {
  return post('/ruyiflow/print/word/data/start', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    viewId,
    formId, templateId, instanceIdList
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

export function actionPrintTaskPoll(store, {taskId}) {
  return post('/ruyiflow/app/form/excel/task/detail', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    taskId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 轨迹图获取数据
export function actionFormViewMapPathData(store, {companyId, appId, formId, viewId, groupFilter}) {
  return post(`/ruyiflow/app/form/view/map/path/data`, {
    userId: store.getters.userId,
    companyId: companyId ? companyId : store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    groupFilter
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 气泡图获取数据
export function actionFormViewBubbleMapData(store, {companyId, appId, formId, viewId, latitude, longitude, distance, sortList, filter, currentPage, pageSize}) {
  return post(`/ruyiflow/app/form/view/map/data`, {
    userId: store.getters.userId,
    companyId: companyId ? companyId : store.getters.currentCompanyId,
    appId,
    formId,
    viewId,
    latitude,
    longitude,
    distance,
    sortList,
    filter,
    currentPage,
    pageSize,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 通过文件下载地址获取文件信息
export function actionFileDownloadUrl2FileInfo(store, {fileUrl}) {
  return post('/fs/file/detail', {
    fileUrl
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

export function actionFetchPersonalizedConfig(store) {
  return axios.get('/personalized/config/get')
    .then(res => res.data)
    .then(({status, resultObject, info}) => {
      console.log('actionFetchPersonalizedConfig' , resultObject)
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取配置页面信息
export function actionThirdLinkPageUrlGet(store, opts) {
  const {
    userId = store.getters.userId,
    companyId = store.getters.currentCompanyId,
    appId = store.getters.currentAppId,
    linkPageId,
    telephone,
    userAgent, //当前 UA
    thirdLinkName, // 第三方链接名称
    openFullScreen,
    openType,
    webUrl,
    mobileUrl,
    openUrlParam, //OPEN 开启 CLOSE 关闭
    paramList,
    openToken, //OPEN 开启 CLOSE 关闭
    tokenId,
    tokenExpireCount, //有效时间长度
    tokenExpireUnit, // HOUR 小时 MIN 分钟 SECOND 秒
  } = opts
  return post('/ruyiflow/third/link/page/url/get', {
    userId,
    companyId,
    appId,
    linkPageId,
    telephone,
    userAgent, //当前 UA
    thirdLinkName, // 第三方链接名称
    openFullScreen,
    openType,
    webUrl,
    mobileUrl,
    openUrlParam, //OPEN 开启 CLOSE 关闭
    paramList,
    openToken, //OPEN 开启 CLOSE 关闭
    tokenId,
    tokenExpireCount, //有效时间长度
    tokenExpireUnit, // HOUR 小时 MIN 分钟 SECOND 秒
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取ip地址
export function getIp(store, {}) {
	return axios.get("https://www.qingmofang.cn/apaas/ip/info", {}).then((res) => {
		var data = res.data
		if (data.status === SUCCESS) {
			var utmApplicationDate = res.headers.date || ''
			return {
				...data.resultObject,
				utmApplicationDate: utmApplicationDate
			}
		} else {
			throw new Error(`${data.status} ${data.info}`)
		}
	})
}

export function utmUploadParam(store, {
 utmPromoteCode,
 utmSourceCode,
 utmContent,
 utmPage,
 utmUserIp,
 utmApplicationDate,
 utmEquipmentType,
 utmSystemType,
 utmUpdateTime,
 utmUserAddress,
 utmBrowser
}) {
  return post('/utm/createInfo', {
   utmPromoteCode,
   utmSourceCode,
   utmContent,
   utmPage,
   utmUserIp,
   utmApplicationDate,
   utmEquipmentType,
   utmSystemType,
   utmUpdateTime,
   utmUserAddress,
   utmBrowser
  },'/apaas/form/api')
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        throw new Error(`${status}:${info}`)
      }
    })
}

export function actionTcTemplateQuery(store, {queryName}) {
  return post('/ruyiflow/template/v2/query', {
    queryName
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取提交前自定义文案
export function actionApplySubmitContent(store, {appId, formId, stepId, data}) {
  return post('/ruyiflow/app/form/apply/submit/content/get', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    stepId,
    data
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 视图按钮点击前，校验
export function actionFetchButtonConfirmCheck(store, {appId, formId, viewId, instanceId, buttonId}) {
  return post(`/ruyiflow/app/form/view/button/execute/check`, {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId,
    instanceId,
    buttonId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS || status === FORM_SUBMIT_ERROR) {
      return {status, resultObject, info}
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status} ${info}`)
    }
  })
}
// 获取平台是否为七牛配置
export function actionCompanyFileType(store) {
  return post('/ruyiflow/company/file/type', {
    companyId: store.getters.currentCompanyId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// 图片调用上传水印信息 /ruyiflow/company/file/waterMark/handle
export function actionFileWaterMarkHandle(store, {appId, formId, data, fileKey, fieldId}) {
  return post('/ruyiflow/company/file/waterMark/handle', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    data,
    fileKey,
    fieldId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 全部成员列表
export function actionCompanyUserListV2(store, {currentPage, pageSize}) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    currentPage,
    pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/member/v2/list', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      let map = {}
      resultObject.dataList.forEach(user => {
        map[user.userId] = user
      })
      store.commit('UPDATE_USER_MAP', map)
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 外部联系人列表
export function actionNewExternalList(store, {filterLabelList, filterType, hasTag, queryStr, currentPage, pageSize}) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    filterLabelList: filterLabelList || [],
    filterType: filterType || 0,
    hasTag: hasTag || 0,
    queryStr,
    currentPage,
    pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/company/ct/external/v2/list", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      let map = {}
      resultObject.dataList.forEach(item => {
        map[item.userId] = item
      })
      store.commit('UPDATE_EXTERNAL_MAP', map)
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 团队部门树
export function actionCompanyDepInfo(store) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/dep/v2/only', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      if (resultObject) {
        store.commit('UPDATE_DEP_INFO', resultObject)
      }
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 部门成员信息
export function actionCompanyDepMemberList(store, {depId, currentPage, pageSize}) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    depId,
    currentPage,
    pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/dep/user/v2/list', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      let map = {}
      resultObject.dataList.forEach(user => {
        map[user.userId] = user
      })
      store.commit('UPDATE_USER_MAP', map)
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 成员搜索
export function actionCompanyMemberSearch(store, {currentPage, pageSize, queryStr}) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    currentPage,
    pageSize,
    queryStr
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/member/v2/query', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      let map = {}
      resultObject.dataList.forEach(user => {
        map[user.userId] = user
      })
      store.commit('UPDATE_USER_MAP', map)
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 离职成员列表
export function actionLeaveMemberList(store) {
  const param = {
    companyId: store.getters.currentCompanyId,
    userId: store.getters.userId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/company/ct/leave/member/list/v2", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_LEAVE_MEMBER_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 离职外部联系人列表
export function actionLeaveExternalList(store) {
  const param = {
    companyId: store.getters.currentCompanyId,
    userId: store.getters.userId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/company/ct/leave/external/list/v2", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_LEAVE_EXTERNAL_LIST', resultObject)
      return resultObject
    } else {
      this._vm.$toast.fail(info)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 获取角色成员列表
export function getRoleMemberList(store, {roleId, currentPage, pageSize}) {
  const param = {
    companyId: store.getters.currentCompanyId,
    userId: store.getters.userId,
    roleId, currentPage, pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/company/ct/role/v2/member/list", encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 全部成员列表
export function actionCompanyUndistributedUserListV2(store, {currentPage, pageSize}) {
  const param = {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    currentPage,
    pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/company/ct/undistributed/v2/member', encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}


// 数据来源控件远程搜索数据
export function actionOptionsSearchData(store, {companyId, appId, formId, fieldId, data, rowIdx, relateDataSourceType, sortList,
  filterInfo, queryStr, advancedFilter, tableFieldId, advancedFilterInfo, relateFieldId, relateAppId, relateFormId, currentPage, pageSize}) {
  return post('/ruyiflow/app/form/apply/search/data', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    rowIdx,
    data,
    relateDataSourceType,
    filterInfo,
    advancedFilter,
    tableFieldId,
    advancedFilterInfo,
    queryStr,
    relateFieldId,
    relateAppId,
    relateFormId,
    sortList,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 数据来源当前子表单某列数据
export function actionOptionsSearchCurrentTableData(store, {companyId, appId, formId, fieldId, currentTableId, dataFieldId, queryStr, data}) {
  return post('/ruyiflow/app/form/current/data/get', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    currentTableId,
    dataFieldId,
    queryStr,
    data
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 数据来源控件远程搜索数据
export function actionOptionsWebhookSearchData(store, {companyId, appId, formId, fieldId, requestType, rowIdx, requestUrl,
  methodType, data, queryStr, headerList, paramType, paramList, requestBody, resultList, updateList, currentPage, pageSize}) {
  return post('/ruyiflow/app/form/webhook/get/data', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    rowIdx,
    data,
    requestType,
    requestUrl,
    methodType,
    headerList,
    paramType,
    paramList,
    queryStr,
    requestBody,
    resultList,
    updateList,
    currentPage,
    pageSize
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 子表单快速分组
export function actionFormTableGroup(store, {appId, formId, tableId, groupList, data}) {
  return post('/ruyiflow/app/form/apply/group/table/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId, tableId, groupList, data
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// 子表单获取分组信息
export function actionFormTableGroupGet(store, {companyId, appId, formId, tableId}) {
  return post('/ruyiflow/app/form/apply/group/table/get', {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId, tableId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// 抄送全部已读
export function actionCcAllRead(store, {companyId, appId, formId}) {
  return post("/ruyiflow/workspace/cc/clear/unread", {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId,
    formId,
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status} ${info}`)
    }
  })
}
// 视图分享获取数据结构-免401接口
export function actionFormViewShareOutGet(store, {shareId}) {
  return post(`/ruyiflow/app/form/view/share/out/get`, {
    shareId
  })
}
// 分享画廊视图数据-免401
export function actionFormViewPhotoShareData(store, {companyId, appId, formId, viewId, filterInfo, requestToken,
  dataMaxIndex, slotDataMaxIndex, maxSlotId, pageSize}) {
  const param = {
    companyId,
    appId,
    formId, viewId, filterInfo, requestToken, dataMaxIndex, slotDataMaxIndex,maxSlotId, pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post(`/ruyiflow/app/form/out/ct/view/share/gallery/data`, encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 外链数据视图表格header
export function actionLinkFormDataViewHeader(store, {companyId, appId, formId, viewId}) {

  const param = {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    viewId
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post("/ruyiflow/app/form/encrypt/view/out/header", encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else if (status === DECODE_ERROR) {
        this._vm.$toast.fail(info)
        throw new Error(`${status}: ${info}`)
      } else {
        this._vm.$toast.fail(info)
        throw new Error(`${status} ${info}`)
      }
    })
}

// 分享表单视图数据-免401
export function actionFormViewShareData(store, {companyId, appId, formId, viewId, sortList, filter, currentPage, pageSize}) {
  const param = {
    companyId,
    appId,
    formId, viewId, sortList, filter, currentPage, pageSize
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post(`/ruyiflow/app/form/out/ct/view/share/table/data`, encodeParam)
    .then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 密码校验-免401接口
export function actionFormViewShareOutPwdCheck(store, {shareId, password}) {
  const param = {
    shareId,
    password
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post(`/ruyiflow/app/form/view/share/out/encrypt/pwd/check`, encodeParam)
}
// 获取子表单流水号
export function actionFetchSubTableSerialNumber(store, {appId, formId, fieldId}) {
  return post('/ruyiflow/app/form/table/serial_no/get', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId: appId || store.getters.currentAppId,
    formId,
    fieldId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 关联审批单
export function actionFetchLarkApplyDataList(store, {appId, formId, fieldId, pageToken, processStatus, tabType}) {
  return post('/ruyiflow/app/form/lark/approval/data/list', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    pageToken, processStatus, tabType
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 刷新全部状态
export function actionFetchLarkApplyDataRefresh(store, {appId, formId, fieldId, data}) {
  return post('/ruyiflow/app/form/lark/approval/data/refresh', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId,
    fieldId,
    data
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 第三方表格数据查询
export function actionFormThirdTableData(store, {appId, formId, fieldId, data}) {
  return post('/ruyiflow/app/form/third/table/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId, //appId
    formId,  //表单的Id
    fieldId,
    data
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// 第三方表格数据查询
export function actionFormThirdMapData(store, {appId, formId, fieldId, data, latitude, longitude, distance}) {
  return post('/ruyiflow/app/form/third/map/data', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId, //appId
    formId,  //表单的Id
    fieldId,
    data,
    latitude,
    longitude,
    distance
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
// 第三方表格数据查询轮训结果
export function actionFormThirdTableDataCycle(store, {taskId}) {
  return post('/ruyiflow/cycle/get/result', {
    userId: store.getters.userId,
    taskId
  })
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        return resultObject
      } else {
        this._vm.$toast.fail(`${status}: ${info}`)
        throw new Error(`${status}: ${info}`)
      }
    })
}
export function actionCustomHomeUserMatch(store) {
  return post('/ruyiflow/company/custom/home/user/match', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail(`请求失败(${info})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 个性化主页详情
export function actionCustomHomeDetail(store, {customId}) {
  return post('/ruyiflow/company/custom/home/detail/v2', {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    customId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      store.commit('UPDATE_USER_MAP', resultObject.memberDetailMap)
      store.commit('UPDATE_EXTERNAL_MAP', resultObject.externalDetailMap)
      return resultObject
    } else if (status !== ERROR && info) {
      this._vm.$toast.fail(`${status}: ${info}`)
      throw new Error(`${status}: ${info}`)
    } else {
      this._vm.$toast.fail(`请求失败(${info})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 仪表盘已发布 布局概览
export function actionDashboardLayoutView(store, opts) {
  const {
    userId = store.getters.userId,
    companyId = store.getters.currentCompanyId,
    appId,
    dashboardId = ''
  } = opts
  return post('/ruyiflow/form/dashboard/layout/view', {
    userId,
    companyId,
    appId: appId || store.getters.currentAppId,
    dashboardId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      throw new Error(`${status}: ${info}`)
    }
  })
}

// 图表数据 拉取
export function actionDashboardChartDataGet(store, opts) {
  const {
    userId = store.getters.userId,
    companyId,
    appId,
    dashboardId,
    chartId = '',
    currentPage = 1,
    pageSize = 20,
    sort = {},
    chart = {},
    filter = {
      relation: 'and',
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    },
    fromView = 'NO', //是否来源于视图
    viewAppId = '', //视图的AppId
    viewFormId= '', //视图的表单Id
    viewId = '' //是否来源于视图 视图Id
  } = opts
  return post('/ruyiflow/form/dashboard/chart/data/get', {
    userId,
    companyId,
    appId,
    dashboardId,
    chartId,
    currentPage,
    pageSize,
    sort,
    chart,
    filter,
    fromView,
    viewAppId,
    viewFormId,
    viewId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS && resultObject.dataHolder && resultObject.dataHolder.dataList) {
      resultObject.dataHolder.dataList.forEach(item => {
        store.commit('UPDATE_USER_MAP', item.memberDetailMap)
        store.commit('UPDATE_EXTERNAL_MAP', item.externalDetailMap)
      })
    }
    return {status, resultObject, info}
  })
}
// 发起表单权限
export function actionFormApplyPermission(store, {appId, formId}) {
  return post("/ruyiflow/mix_form/form/apply/permission", {
    userId: store.getters.userId,
    companyId: store.getters.currentCompanyId,
    appId,
    formId
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
// 关联查询字段查数据
export function actionFormLinkQueryData(store, {companyId, appId, formId, fieldId, data}) {

  const param = {
    userId: store.getters.userId,
    companyId: companyId || store.getters.currentCompanyId,
    appId, //appId
    formId,  //表单的Id
    fieldId,
    data
  }
  const encodeParam = {
    requestParam: encodeData({
      type: ENCODE_TYPE_ZEUS,
      data: param
    })
  }
  return post('/ruyiflow/app/form/link/ct/query/data', encodeParam)
    .then(({status, resultObject, info}) => {
      if (status === SUCCESS) {
        resultObject.dataList.forEach(item => {
          store.commit('UPDATE_USER_MAP', item.memberDetailMap)
          store.commit('UPDATE_EXTERNAL_MAP', item.externalDetailMap)
        })
        return resultObject
      } else {
        this._vm.$toast.fail(`${info}(${status})`)
        throw new Error(`${status}: ${info}`)
      }
    })
}

// 获取拉起小程序 url scheme
export function actionMiniappUrlScheme(store, {jumpPage, queryParam, envVersion}) {
  return post("/wechat/miniapp/url_scheme/generate", {
    jumpPage, queryParam, envVersion
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      return resultObject
    } else {
      this._vm.$toast.fail(`${info}(${status})`)
      throw new Error(`${status}: ${info}`)
    }
  })
}
